module.exports = __webpack_public_path__ + "img/loupe-anim.f07d71a.svg";